import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'projects-task-check-button',
  standalone: true,
  imports: [],
  templateUrl: './projects-task-check-button.component.html',
  styleUrl: './projects-task-check-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectsTaskCheckButtonComponent {
  @Input() selected: boolean;
  @Input() width: string = '129px';
  @Input() flexGrow: boolean;

  @Output() buttonClick = new EventEmitter<void>();
}
